import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleFormVariantEnum, VehicleFormVariantType } from '../../shared/interfaces/form';

@Injectable({
    providedIn: 'root',
})
export class VehicleSelectFormsService {

    public constructor(
        private readonly forms: FormBuilder,
    ) { }

    public createVehicleSelectFormGroup(
        variant: VehicleFormVariantType,
        initial?: {
            make_id?: number,
            model_id?: number,
            trim_id?: number
        },
    ): FormGroup {
        switch(variant) {
            case VehicleFormVariantEnum.DEFAULT:
                return this.defaultVehicleSelectFormGroup(initial);
            default:
                return this.defaultVehicleSelectFormGroup(initial);
        }
    }

    private defaultVehicleSelectFormGroup(
        initial?: {
            make_id?: number,
            model_id?: number,
            trim_id?: number,
        },
    ): FormGroup {
        return this.forms.group({
            make_id: [initial?.make_id, Validators.required],
            model_id: [initial?.model_id, Validators.required],
            trim_id: [initial?.trim_id],
        });
    }
}
